import { Divider, Input, Row } from "antd";
import { ComplementModel } from "api/generated";
import { FormItem } from "common/components/form/FormItem";
import ResponsiveCol from "common/components/form/ResponsiveCol";
import { ExtraInfoBtn } from "common/helpers/generalUtils";

export function ClarificationComplementForm() {
  return (
    <div>
      <Divider
        orientation="left"
        style={{ fontSize: "15px", borderColor: "#49f5f5ff" }}
      >
        Complemento - Aclaración
      </Divider>
      <Row gutter={24}>
        <FormItem<ComplementModel>
          hidden
          label="clarification_id"
          name={["clarification", "id"]}
        />

        <ResponsiveCol size="xl">
          <FormItem<ComplementModel>
            label={
              <div>
                <span>Aclaración</span>
                {ExtraInfoBtn("Aclaración", [
                  "Debes registrarlo en caso de que desees redactar aclaraciones o justificaciones.",
                  "Ejemplo: Aclaracion = No se emitió CFDI por la operación correspondiente al registro de recepción número 345 en el día de la generación del reporte.",
                ])}
              </div>
            }
            name={["clarification", "description"]}
            rules={[
              { required: true, message: "Este campo es obligatorio" },
              {
                min: 10,
                message: "Introduce mínimo 10 caracteres.",
              },
            ]}
          >
            <Input.TextArea placeholder="Descripción" rows={10} prefix="ss" />
          </FormItem>
        </ResponsiveCol>
      </Row>
    </div>
  );
}
